// Libraries
import { HStack, Text } from '@chakra-ui/react';
import { createElement } from 'react';
// Components
import { RoundedCheckIcon, RoundedCrossIcon } from '@atoms/index';
import { ValidationTextProps } from './ValidationText.type';

/**
 * Renders a validation text component.
 *
 * @component
 * @param {ValidationTextProps} props - Props for the ValidationText component.
 * @param {boolean} props.value - The value to validate.
 * @param {boolean} props.validation -  The regular expression for validation.
 * @param {boolean} props.wasSubmitted - Indicates if the form was submitted.
 * @param {boolean} props.text - The text to be displayed.
 * @returns {ReactElement} The ValidationText component.
 */
export const ValidationText = ({ value, validation, wasSubmitted, text }: ValidationTextProps) => {
  const isValid = validation.test(value);
  const icon = isValid ? RoundedCheckIcon : RoundedCrossIcon;
  const ml = wasSubmitted ? 1 : 6;

  return (
    <HStack>
      {wasSubmitted && createElement(icon, { w: 4 })}
      <Text fontSize='sm' ml={ml}>
        {text}
      </Text>
    </HStack>
  );
};
